let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4vd8Z")).then(() => parcelRequire('4yoHz'));